import type { FaireProductEntity } from "../../entity_types/product";

export const p_4k6668j6u6: FaireProductEntity = {
  token: "p_4k6668j6u6",
  type: "product",
  name: "Copper Bracelet with Magnets",
  brandToken: "b_fpfqb8hgs8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/05894baf2e6ac02471e35c243a0e287d75882b11f72d7b8bab752139f4a79105.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d44dbcacab41921baf5ad9672a5ebb57a5560df0d49ec11558baa48c17086c93.jpeg",
    "https://cdn.faire.com/fastly/02b1583270654b11fc11926fa4c990d36021f389774910f14633915e2846a14e.jpeg",
    "https://cdn.faire.com/fastly/9e5d512349f3063bcf70ce678175a59b22ef7437bff5d7bf0d26b1d80c1a47c8.jpeg",
    "https://cdn.faire.com/fastly/9ee84ee0cf3f8ce3e655323aa5681a7cfefad4c4d18af518c25a916a3d4f8754.jpeg",
    "https://cdn.faire.com/fastly/a7c326434807d35be3e4513aa094c9488a14cdf9b4075adc3769059e65efd2ec.jpeg",
    "https://cdn.faire.com/fastly/5856b5f2bacd25d844012a37b5b8defac845dbf1c2e040c1495a9c3e31ead70a.jpeg",
    "https://cdn.faire.com/fastly/f2e81947de201f290cf7110eb3e42a6d48ae985b6c9365b1c73cf72f8287ef90.jpeg",
    "https://cdn.faire.com/fastly/6662aa003063ef288239fffc7a9870be1c298a0a7009fc81471a068c067c00a5.jpeg",
    "https://cdn.faire.com/fastly/8aed22a10cba8c59ea01bb0996d726bb5d8627cc14ab95a6b99fe8e23c7fa15f.jpeg",
    "https://cdn.faire.com/fastly/7531450bd15b39131cd17c87cf7c366f5f63354d124ffdb95943a674192596d6.jpeg",
  ],
  priceDollars: 6.24,
  description:
    'This adjustable Copper Bracelet with Magnets combines timeless style with potential wellness benefits.\n\nCrafted from high-quality copper, its sleek design fits comfortably on the wrist while the embedded magnets offer a subtle nod to holistic wellness.\n\nPerfect for everyday wear or layering with other bracelets.\n\nThese bracelets are popular for both aesthetic and supposed health benefits.\n\nSupposed to improve blood circulation and reduce inflammation. Has magnets for additional effects.\n\nImportant Note: Scientific studies have not confirmed significant health benefits from wearing copper bracelets. Most evidence points to a placebo effect rather than a direct therapeutic impact.\n\nSize: Adjustable bracelet with minimum dia of 2 1/4"\n\n1 1/4" width\n\nHandmade in India by our fair trade artisan partners.\n\n',
  tags: [],
  msrpDollars: 12.47,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:26.261Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
